import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

/**
 * Checkout T&C schema
 */
export const tcSchema = z.object({
  checked: z
    .boolean()
    .default(false)
    .refine((val) => val === true, {
      message: mxTranslations?.Checkout?.must_check_option || 'You must check this option to continue',
    }),
})

/**
 * Export checkout T&C type
 */
export type TTcSchema = z.infer<typeof tcSchema>
